import type { ReactNode } from 'react';

type MiddlePageGradientProps = {
  children: ReactNode;
};

export const SectionGradient = ({ children }: MiddlePageGradientProps) => {
  return (
    <div className="w-full relative max-w-full flex justify-center">
      <div
        className="-z-[1] h-[444px]
          absolute top-0 left-0 bottom-0 right-0
          bg-gradient-to-br from-[#FF8066] via-[#E566FF] to-[#66B2FF]
          blur-[83px] opacity-[0.08] rounded-full
        "
      />
      <div className="relative w-full flex justify-center">{children}</div>
    </div>
  );
};
